import React from 'react';
import './review.scss';
import Image from '../../../components/image';
const Review = ({ image, name, bio, text }) => {
	return (
		<div className='review'>
			<div className='person'>
				<div className='person-image'>
					<Image src={image} />
				</div>
				<div className='person-details'>
					<h3>{name}</h3>
					{/* <p>{bio}</p> */}
				</div>
			</div>
			<div className='text'>
				<p>{text}</p>
			</div>
		</div>
	);
};

export default Review;
